import type { EdgeMarker, EdgeMarkerType } from 'reactflow'
import type { CustomEdgeType } from 'src/newComponents/edges/customEdge'

export function getEdgeColor(hasErr?: boolean, selected?: boolean) {
  return selected ? '#5582f3' : hasErr ? 'red' : '#b2b2b8'
}

export function getMarkerEndStyle(markerEnd: (EdgeMarkerType | undefined) & EdgeMarkerType, hasErr?: boolean, selected?: boolean): EdgeMarker {
  markerEnd = markerEnd ? { ...(markerEnd as EdgeMarker) } : ({} as EdgeMarker)
  return {
    ...markerEnd,
    color: getEdgeColor(hasErr, selected),
  }
}

export function getEdgeStyle(style?: React.CSSProperties, hasErr?: boolean, selected?: boolean): React.CSSProperties {
  style = style ? { ...style } : ({} as React.CSSProperties)
  return {
    ...style,
    stroke: getEdgeColor(hasErr, selected),
  }
}

export function getEdgeAndMarkerEndStyle(markerEnd: (EdgeMarkerType | undefined) & EdgeMarkerType, style?: React.CSSProperties, hasErr?: boolean, selected?: boolean) {
  return {
    markerEnd: getMarkerEndStyle(markerEnd, hasErr, selected),
    style: getEdgeStyle(style, hasErr, selected),
  }
}

export function sortEdges(a: CustomEdgeType, b: CustomEdgeType) {
  if (a.selected === b.selected) {
    return Number(a.data!.hasErr === true) - Number(b.data!.hasErr === true)
  }
  else {
    return Number(a.selected === true) - Number(b.selected === true)
  }
}
